interface Config {
  API_URL?: string;
  API_TIMEOUT?: number;
  DEBUG_MODE?: boolean;
  APP_VERSION?: string;
  DEFAULT_PAGE_SIZE?: number;
  [key: string]: any;
}

class ConfigService {
  private config: Config | null = null;
  private loading: Promise<Config> | null = null;

  async loadConfig(): Promise<Config> {
    if (this.config) {
      return this.config;
    }

    if (this.loading) {
      return this.loading;
    }

    this.loading = fetch(`${process.env.PUBLIC_URL}/js/config.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load config: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then(config => {
        this.config = config;
        return config;
      })
      .catch(error => {
        console.error('Error loading configuration:', error);
        this.config = {
          API_URL: 'http://localhost:4000',
          API_TIMEOUT: 30000,
          DEBUG_MODE: false,
          APP_VERSION: '1.0.0',
          DEFAULT_PAGE_SIZE: 10
        };
        return this.config;
      });

    return this.loading;
  }

  async get<T>(key: string, defaultValue: T): Promise<T> {
    const config = await this.loadConfig();
    return (config[key] !== undefined ? config[key] : defaultValue) as T;
  }
}

// Create a singleton instance
const configServiceInstance = new ConfigService();
// Export as singleton
export default configServiceInstance;